import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, Radio, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, Cancel, CancelOutlined } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import BookingConfirmAlert from "../../components/Alert/BookingConfirmAlert.jsx";
import Axios from "axios";
import { getCookies } from "../../utils/getToken.js";
import { NotificationManager } from "react-notifications";
import Moment from "moment";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import TermsOfUseAlert from "../../components/Alert/TermsOfUseAlert.jsx";
import CancellationPolicyAlert from "../../components/Alert/CancellationPolicyAlert.jsx";
let isMounted = false;

var authToken = getCookies();


const styles = (theme) => ({
    card: {
        color: theme.palette.secondary.main,
    },
});
const sendProps = (props) => {
    const { classes, ...rest } = props;
    return rest;
};
class ConfirmBookingScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            update: false, 
            showAlert: false,
            showTermOfUseAlert: false,
            booking_agree: 0,
            bookingDetailsConfirmPrev: this.props.history.location.state.bookingDetails,
            bookingInfoDataPrev: this.props.history.location.state.bookingInfoData,
            additionDataPrev: this.props.history.location.state.aditionalData,
            addressData: [],
            addressId:'',
            cardListNew : [],
            ref_flag:false,
            refer_code: '',
            bookingAgreeError: false
        };
    }
    componentDidMount() {
        // console.log("bookingDetailsConfirmPrev", this.state.bookingDetailsConfirmPrev);
        console.log("this.state.bookingInfoDataPrev.booking_date", this.state.bookingInfoDataPrev.booking_date);
        // console.log("additionDataPrev", this.state.additionDataPrev);
        // console.log("cardListNew", this.state.cardListNew);

        this.getAddressData();
        this.getCardList()
    }

    getAddressData() {
        this.props.getAddressListAction(this.onGetAddressDone);
    }

    getCardList(){
        this.props.cardListAction(this.onCardlistDone);
    }

    onGetAddressDone = (success, data) => {
        if (success) {
            this.setState({ 
                addressData: data.detail.addresses[0],
                addressId: data.detail.addresses[0].key,
                refer_code: data.detail.referral_code,
                // key
            });
        }
        console.log("ADDRESSS NEWWWWWW", this.state.addressData);
    };

    onCardlistDone = (success, data) => {
        if (success) {
            this.setState({ cardListNew: data.sources.data[0]});
        }
        // console.log("CARDDDDDDSSS NEWWWWWW", this.state.cardListNew);
    };

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    handleRadioChange = event => {
        this.setState({ booking_agree: event.target.value, bookingAgreeError: false})
        //    this.setState({color: '#0078ff'});
    };

    onBookNowStart = async () => {
        // let token = await AsyncStorage.getItem('userToken');
        // startAnimation();
        // let myNewDate = this.state.bookingInfoDataPrev.booking_date;
        // console.log("myNewDate", myNewDate);
        const orgDate = this.state.bookingInfoDataPrev.booking_date
        const event = new Date(orgDate);
        let splittedDate = event.toLocaleString().split(',')[0];
        console.log("splittedDate NEWW", splittedDate);

        var date = splittedDate;
        var newdate = date.split("/").reverse().join("-");
        console.log("newdate", newdate);

        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        this.setState({
          showAlert: false
        })
        try {
          const {data} = await Axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/booking/confirm`,
            data: {
               task_id:this.state.bookingInfoDataPrev.task_id,
               service_id: this.state.bookingInfoDataPrev.service_id,
               category_id: this.state.bookingInfoDataPrev.category_id,
               booking_value: this.state.bookingInfoDataPrev.booking_value,
               booking_quantity: this.state.bookingInfoDataPrev.booking_quantity,
               booking_slot: this.state.bookingInfoDataPrev.booking_slot,
            //    booking_date: this.state.bookingInfoDataPrev.booking_date,
                booking_date: newdate,
               home_instruction: this.state.additionDataPrev.home_instruction,
               instructions: this.state.additionDataPrev.instructions,
               home_stay: this.state.additionDataPrev.home_stay,
               address_line1: this.state.addressData.address_line1,
               city: this.state.addressData.city,
               state: this.state.addressData.state,
               country: this.state.addressData.country,
               refer_code: this.state.refer_code,
               pay_amount: this.state.bookingInfoDataPrev.booking_value,
               ref_flag: this.state.ref_flag,
               booking_img1: this.state.additionDataPrev.booking_img_1,
               booking_img2: this.state.additionDataPrev.booking_img_2,
               booking_img3: this.state.additionDataPrev.booking_img_3,
               booking_img4: this.state.additionDataPrev.booking_img_4
            },
            headers: {
              'x-auth-Token': authToken,
            },
          });
          console.log('BOOKINGG DATA', data);
          if (data.status == 'OK') {
            this.setState({
              loading:false
            })
            NotificationManager.success(data.message, 'Success');
            this.props.history.push('/user/booking_success', {bookingSuccessData: data})
          }
          else{
            this.setState({
              loading:false
            })
            NotificationManager.error(data.message, 'Error');
            this.props.history.push('/user/dashboard')
            // alertError(this,data.message)
            // this.props.navigation.navigate('HomeScreen');
          }
        } catch (error) {
          console.log("=================================================================================================BOOKING ERRORRRRRR",error);
        }
      };

    render() {
        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        var card={
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            borderRadius: '10px',
            marginBottom: 20,
            // marginRight: 20,
            padding: 20,
            width: '30%'
        }
        var cardHeading={
            backgroundColor: '#0078ff',
            color: 'white',
            fontWeight: '600',
            padding: '5px 20px',
            borderRadius: 50
        }
        var infoHead={
            color: 'green',
            fontSize: 18,
            fontWeight: '700'
        }

        const orgDate = this.state.bookingInfoDataPrev.booking_date
        const event = new Date(orgDate);
        let splittedDate = event.toLocaleString().split(',')[0];
        console.log("splittedDate NEWW", splittedDate);

        var monthNames = [ "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December" ];
    
        let originalDate = splittedDate;
        console.log('originalDate', originalDate);
        let year = originalDate.substring(6,10)
        let month = ( Number(originalDate.substring(3,5)) - 1 );
        let date = originalDate.substring(0,2)
    
        let formattedDate = monthNames[month] + ' ' + date + ', ' + year;
        console.log('formattedDate NEW', formattedDate);

        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Confirm Booking' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                }}>
                                    <div style={card}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}>
                                                <p style={cardHeading}>Booking Info</p>
                                                <p 
                                                    style={{
                                                        textDecoration: 'underline',
                                                        color: '#0078ff',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={()=> this.props.history.push('/user/booking_schedule', 
                                                    {
                                                        taskData: this.state.bookingDetailsConfirmPrev, 
                                                        bookingInfoData : this.state.bookingInfoDataPrev,
                                                        BookingPath: 'edit',
                                                        bookingDateEdit: this.state.bookingInfoDataPrev.originalCalendarDate,
                                                        bookingSlotEdit: this.state.bookingInfoDataPrev.booking_slot
                                                    }
                                                    )}
                                                >Edit</p>
                                            </div>
                                            <p style={infoHead}>
                                                {formattedDate}
                                            </p>
                                            <p>{this.state.bookingInfoDataPrev.booking_slot}</p>
                                            <p>{this.state.bookingInfoDataPrev.task_name} ({this.state.bookingInfoDataPrev.category_name} / {this.state.bookingInfoDataPrev.service_name})</p>
                                            <p>Description: {this.state.bookingDetailsConfirmPrev.description}</p>
                                            <p>Booking Type: {this.state.bookingDetailsConfirmPrev.service_type} | {this.state.bookingDetailsConfirmPrev.booking_type}</p>
                                            <p>Booking Unit: {this.state.bookingInfoDataPrev.booking_quantity}</p>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}>
                                                <p>Total Charges: ${this.state.bookingInfoDataPrev.booking_value}</p>
                                                <p 
                                                    style={{
                                                        textDecoration: 'underline',
                                                        color: '#0078ff',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={()=> this.props.history.push('/user/additional_info', 
                                                    {
                                                        taskBooking: this.state.bookingDetailsConfirmPrev, 
                                                        bookingInfoData : this.state.bookingInfoDataPrev
                                                    }
                                                    )}
                                                >Edit Aditional Info</p>
                                            </div>
                                    </div>
                                    <div style={card}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}>
                                                <p style={cardHeading}>Booking Address</p>
                                                
                                                {
                                                    authToken == 'Guest'
                                                    ?
                                                    <p  
                                                    onClick={()=> this.props.history.push('/user/signin')}
                                                    style={{
                                                        textDecoration: 'underline',
                                                        color: '#0078ff',
                                                        cursor: 'pointer'
                                                    }}>
                                                        Login
                                                    </p>
                                                    : !this.state.addressData
                                                        ? <p  style={{
                                                            textDecoration: 'underline',
                                                            color: '#0078ff',
                                                            cursor: 'pointer'
                                                        }}>
                                                            Add
                                                        </p>
                                                        : <p
                                                        style={{
                                                            textDecoration: 'underline',
                                                            color: '#0078ff',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={()=> this.props.history.push({
                                                            pathname: `/user/address/update/${this.state.addressId}`,
                                                            state: { item: this.state.addressData }
                                                        })}
                                                    >Edit</p>
                                                }
                                            </div>
                                            {
                                                this.state.addressData
                                                ?
                                                <div>
                                                    <p style={infoHead}>{this.state.addressData.city}</p>
                                                    <p>{this.state.addressData.address_line1}</p>
                                                    <p>State - {this.state.addressData.state}</p>
                                                    <p>Zip - {this.state.addressData.zipcode}</p>
                                                </div>
                                                : null
                                            }
                                    </div>
                                    <div style={card}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}>
                                                <p style={cardHeading}>Payment Method</p>
                                                
                                                {
                                                    authToken == 'Guest'
                                                    ?
                                                    <p  
                                                    onClick={()=> this.props.history.push('/user/signin')}
                                                    style={{
                                                        textDecoration: 'underline',
                                                        color: '#0078ff',
                                                        cursor: 'pointer'
                                                    }}>
                                                        Login
                                                    </p>
                                                    : !this.state.cardListNew
                                                        ? <p  style={{
                                                            textDecoration: 'underline',
                                                            color: '#0078ff',
                                                            cursor: 'pointer'
                                                        }}>
                                                            Add
                                                        </p>
                                                        : <p
                                                        style={{
                                                            textDecoration: 'underline',
                                                            color: '#0078ff',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={()=> this.props.history.push('/user/profile')}
                                                    >Edit</p>
                                                }
                                                
                                            </div>
                                            {
                                                this.state.cardListNew
                                                ? 
                                                    <div>
                                                        <p style={infoHead}>Card - {this.state.cardListNew.brand}</p>
                                                        <p>Card Number - **** **** **** {this.state.cardListNew.last4}</p>
                                                        <p>Expiry - {this.state.cardListNew.exp_month}/{this.state.cardListNew.exp_year}</p>
                                                        <p>Amount Payable - ${this.state.bookingInfoDataPrev.booking_value}</p>
                                                    </div>
                                                : null
                                            }
                                    </div>
                               </div>
                               <div>
                                    {
                                        this.state.bookingAgreeError 
                                        ? <p style={{color: 'red', fontSize: 17, marginLeft: 47}}>Please accept Terms and Condition</p>
                                        : null
                                    }
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        // justifyContent: 'center',
                                        marginTop: 35
                                    }}>
                                        <Radio
                                            className="checked-radio"
                                            checked={
                                                this.state.booking_agree==1
                                            }
                                            onChange={event => this.handleRadioChange(event)}
                                            // onChange={this.handlePaymentOption}
                                            value="1"
                                            color="primary"
                                             style={{ }}
                                        /><p style={{
                                            fontSize: 18
                                        }}>I understand that I am purchasing a service subject to ezPro's{" "}
                                            <span
                                                onClick={()=> this.setState({showTermOfUseAlert: true})} 
                                                style={{
                                                    color: '#0078ff', 
                                                    textDecoration: 'underline', 
                                                    cursor: 'pointer'
                                                }}>Term of use
                                            </span> 
                                            {" "}and{" "}
                                            <span 
                                                onClick={()=> this.setState({showCancellationPolicyAlert: true})} 
                                                style={{
                                                    color: '#0078ff', 
                                                    textDecoration: 'underline', 
                                                    cursor: 'pointer'
                                                }}>Cancellation Policy
                                            </span> 
                                            {" "}and my payment method will be charged before the service.</p>
                                    </div>
                                    
                               </div>
                            </div>
                            <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginTop: 70,
                                    marginRight: 30
                                }}>
                                    <p 
                                    onClick={() => this.props.history.push('/user/dashboard',)}
                                    style={{
                                        backgroundColor: 'red',
                                        padding: '7px 20px',
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>Cancel</p>
                                    <p 
                                    // onClick={() => this.props.history.push('/user/additional_info',)}
                                    // onClick={()=> 
                                    //     this.state.booking_agree === 0 
                                    //     ? this.setState({bookingAgreeError: true})
                                    //     : authToken == 'Guest' 
                                    //         ? this.props.history.push('/user/signin')
                                    //         : this.setState({showAlert: true})
                                    // }

                                    onClick={() => {
                                        if (this.state.booking_agree === 0) {
                                            this.setState({ bookingAgreeError: false});
                                        } else if (authToken === 'Guest') {
                                            
                                            this.props.history.push('/user/signin');
                                        } else {
                                            
                                            this.setState({ showAlert: true });
                                        }
                                    }}
                                    


                                    style={{
                                        backgroundColor: '#0078ff',
                                        padding: '7px 20px',
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        marginLeft: 20
                                    }}>Book Now</p>
                                </div>
                        </div>
                    </div>
                </div>
                <BookingConfirmAlert
                    open={this.state.showAlert}
                    title=""
                    close={() => this.setState({ showAlert: false })}
                    handleYes={this.onBookNowStart}
                    handleNo={() => this.setState({ showAlert: false })}
                />
                <TermsOfUseAlert
                    open={this.state.showTermOfUseAlert}
                    title=""
                    content="By accepting this you agree with the adjusted pricing shown above. You will be automatially charged the difference between the orginal amount and the new amount you are accepting. Do you want to continue?"
                    close={() => this.setState({ showTermOfUseAlert: false })}
                    // handleYes={this.onBookNowStart}
                    handleYes={() => this.setState({ showTermOfUseAlert: false })}
                    handleNo={() => this.setState({ showTermOfUseAlert: false })}
                />
                <CancellationPolicyAlert
                    open={this.state.showCancellationPolicyAlert}
                    title=""
                    content=""
                    close={() => this.setState({ showCancellationPolicyAlert: false })}
                    // handleYes={this.onBookNowStart}
                    handleYes={() => this.setState({ showCancellationPolicyAlert: false })}
                    handleNo={() => this.setState({ showCancellationPolicyAlert: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers, bookings }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader,
        cardList: bookings.cardList,
        cardLoader: bookings.cardLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(ConfirmBookingScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/ConfirmBookingScreenNew.jsx